const schemaFieldMap = {
  AMZWeekly: 'date',
  CustomerDeliveryFeedback: 'date',
  Device: 'updated_at',
  DriverPictureTaken: 'driver_route_date',
  eMentor: 'date',
  Employee: 'date_created',
  NetradyneEOC: 'date',
  Shift: 'route_date',
  Station: 'summary_date',
  Vehicle: 'last_used_at_date',
  VehicleTaskTracker: 'pm_date',
};

export const getTimeDimensionName = (schema) => {
  const field = schemaFieldMap[schema];
  return field ? `${schema}.${field}` : null;
};

export { schemaFieldMap };
